import { useMemo } from 'react';
import type { File } from '@dev-streetbeat/chat/types';
import { AttachmentsIcon } from 'shared/assets/svg/menu-icons/AttachmentsIcon';
import colorsStore from 'shared/store/colorsStore';

import { getFileDisplayType } from 'utils/attachmentUtils';
import styles from './AttachmentItem.module.scss';
import useToggleMenu from 'shared/layout/useToggleMenu';

type Props = {
  file: File;
};

export const AttachmentItem: React.FC<Props> = ({ file }) => {
  const colorsConfig = colorsStore((state) => state.colorsConfigStore);
  const fileNameWithoutExtension = file.name.replace(/\.[^/.]+$/, '');

  const fileType = useMemo(() => getFileDisplayType(file), [file]);

  const toggleMenu = useToggleMenu();

  const handleItemClick = () => {
    const el = document.getElementById(file.id.toString());
    el?.scrollIntoView({ block: 'center', behavior: 'smooth' });
    toggleMenu();
  };

  return (
    <div className={styles.attachmentItem} onClick={handleItemClick}>
      <div className={styles.attachmentIconWrapper}>
        <AttachmentsIcon size={20} color={colorsConfig.chatCopyColor} />
      </div>
      <div className={styles.attachmentContent}>
        <div className={styles.attachmentFileName}>{fileNameWithoutExtension}</div>
        <div className={styles.attachmentFileType}>{fileType}</div>
      </div>
    </div>
  );
};
